function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x2: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00ccbf",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00b265",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x2: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#151515",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#353535",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x2: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9cc0b7",
  offset: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "m357.01 2e-3h309.98c102.8 0 154.2 0 209.53 17.495 60.409 21.988 108 69.575 129.99 129.99 17.493 55.33 17.493 106.73 17.493 209.53v309.98c0 102.8 0 154.2-17.493 209.53-21.99 60.409-69.577 108-129.99 129.98-55.334 17.497-106.73 17.497-209.53 17.497h-309.98c-102.8 0-154.2 0-209.53-17.497-60.411-21.986-108-69.573-129.99-129.98-17.495-55.334-17.495-106.73-17.495-209.53v-309.98c0-102.8 0-154.2 17.495-209.53 21.988-60.411 69.575-108 129.99-129.99 55.33-17.495 106.73-17.495 209.53-17.495"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "m512.5 67c246.04 0 445.5 199.26 445.5 445.06 0 245.8-199.46 445.06-445.5 445.06s-445.5-199.26-445.5-445.06c0-245.8 199.46-445.06 445.5-445.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "m697.87 765.87-74.694-103.5c46.911-34.305 77.384-89.713 77.384-152.24 0-104.14-84.504-188.56-188.75-188.56-104.24 0-188.74 84.42-188.74 188.56 0 62.801 30.741 118.42 78.001 152.69l-74.75 103.58c-79.46-57.457-131.16-150.86-131.16-256.35 0-174.67 141.74-316.26 316.58-316.26s316.58 141.6 316.58 316.26c0 105.16-51.391 198.32-130.44 255.82zm-185.44-332.14c42.062 0 76.161 34.065 76.161 76.085 0 42.021-34.099 76.085-76.161 76.085-42.063 0-76.161-34.064-76.161-76.085 0-42.02 34.098-76.085 76.161-76.085z"
}));

function SvgCastro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastro);
export default __webpack_public_path__ + "static/media/castro.3c1ee65f.svg";
export { ForwardRef as ReactComponent };